import { ReactNode } from 'react'

export default function InputRowWrapper({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}): React.ReactElement {
  return (
    <div className={`flex items-center text-md sm:text-lg font-semibold text-purple ${className ?? ''}`}>
      {children}
    </div>
  )
}
